import styled from 'styled-components'

import { candidateInitials } from '@/app/2023/consejo/candidatos/components/CandidatesTable'
import listas from '@/app/2023/consejo/types/listas'
import CircleMesh, {
  TCircleEventReturn,
  TOnCircleClick,
} from '@/app/components/CircleMesh/CircleMesh'
import TwitterLinkBase from '@/app/components/TwitterLink'
import { spaces } from '@/config/global-parameters'

import { IGanadorWithData } from '../../types/ganadores'
import FadeCandidate from './FadeCandidate'

export interface ICircleGraph {
  className?: string
  nRows?: number // Numero de circulos por fila
  gap?: string // Espacio entre ciruclos
  nColumns?: number
  candidates: IGanadorWithData[]
  onCircleClick?: TOnCircleClick<IGanadorWithData>
  onCircleMouseEnter?: TOnCircleClick<IGanadorWithData>
  onCircleMouseLeave?: TOnCircleClick<IGanadorWithData>
  selectedCandidate?: IGanadorWithData | undefined
}

const CircleGraph = ({
  className,
  gap = '6px',
  nRows = 2,
  candidates,
  nColumns = Math.ceil(candidates.length / nRows),
  onCircleClick,
  onCircleMouseEnter,
  onCircleMouseLeave,
  selectedCandidate,
}: ICircleGraph) => {
  const cicleWidth = `calc((100% - (${gap} * (${nColumns - 1}))) / ${nColumns})`
  const circles = candidates
    .sort(({ lista: listaA }, { lista: listaB }) => listas[listaA].order - listas[listaB].order)
    .map((candidate) => {
      const {
        apellido_paterno: apellidoPaterno,
        id,
        lista,
        nombre_completo: nombreCompleto,
        photo_path: photoPath,
      } = candidate
      const isSelected = selectedCandidate?.id === id
      return {
        children: (
          <FadeCandidate
            color={listas[lista].color}
            imagePath={photoPath}
            isSelected={isSelected}
            text={candidateInitials({ apellidoPaterno, nombreCompleto })}
            width="100%"
          />
        ),
        color: listas[lista].color,
        data: candidate,
        key: id,
        opaque: false,
      }
    })

  const handleCircleClick = (e: TCircleEventReturn<IGanadorWithData>) => {
    if (onCircleClick && e.data?.id !== '') onCircleClick(e)
  }
  const handleCircleMouseEnter = (e: TCircleEventReturn<IGanadorWithData>) => {
    if (onCircleMouseEnter && e.data?.id !== '') onCircleMouseEnter(e)
  }
  const handleCircleMouseLeave = (e: TCircleEventReturn<IGanadorWithData>) => {
    if (onCircleMouseLeave && e.data?.id !== '') onCircleMouseLeave(e)
  }

  return (
    <Wrapper className={className}>
      <CircleMesh
        circles={circles}
        gap={gap}
        nColumns={nColumns}
        nRows={nRows}
        onCircleClick={handleCircleClick}
        onCircleMouseEnter={handleCircleMouseEnter}
        onCircleMouseLeave={handleCircleMouseLeave}
        width={cicleWidth}
      />
      <TwitterLink />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${spaces.xs};
  @media (max-width: ${spaces.tabletBreakpoint}) {
    flex-flow: column-reverse nowrap;
    gap: ${spaces.xs};
  }
`
const TwitterLink = styled(TwitterLinkBase)`
  text-align: right;
  width: min-content;
  align-self: flex-end;

  @media (max-width: ${spaces.tabletBreakpoint}) {
    align-self: center;
  }
`

export default CircleGraph
